module.exports = __webpack_public_path__ + "static/political-order-and-political-decay-8a500e4b4332bfd73013975657c7b14f.jpg";